import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { ThreeDots } from 'react-loader-spinner';

const Index = ({
  value,
  dropdownId,
  selectedIds,
  isLoading,
  onChange,
  placeHolder,
  fetch,
  hasMore,
  takeSize,
  isPaginated
}) => {
  const [visible, setVisible] = useState(false);
  const menuRef = useRef();
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [skip, setSkip] = useState(0);
  const [searchString, setSearchString] = useState('');

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const searchHandler = (searchString) => {
    setSearchString(searchString);

    if(isPaginated)
      fetch(0, true , searchString);
  };

  const filteredData = useMemo(() => {
    if (isPaginated) return value;

    return value.filter(item =>
      item.name?.toLowerCase().includes(searchString.toLowerCase())
    );
  }, [value, searchString, isPaginated]);

  const handleScroll = () => {
    if (!menuRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = menuRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 5 && !isAtBottom) {
      setIsAtBottom(true);
    }
  };

  useEffect(() => {
    if (isAtBottom) {
      setIsAtBottom(false);
      if (hasMore) {
        const skipValue = skip + takeSize;
        fetch(skipValue, false, searchString);
        setSkip(skipValue);
      }
    }
  }, [isAtBottom]);

  useEffect(() => {
    if (menuRef.current && isPaginated) {
      menuRef.current.addEventListener('scroll', debouncedHandleScroll);
      return () => menuRef.current?.removeEventListener('scroll', debouncedHandleScroll);
    }
  }, [visible]);

  const debouncedHandleScroll = debounce(handleScroll, 200);

  const menu = (
    <div
      ref={menuRef}
      className='custom-scrollbar'
    >
      <Menu className='w-100 folder-dropdown' multiple onSelect={onChange} onDeselect={onChange}>
        <div className="custom-search position-relative mb-3">
          <FontAwesomeIcon icon={faSearch} />
          <input type="text" onChange={(e) => searchHandler(e.target.value)} className="form-control" />
        </div>
        <>
          {filteredData?.map((item, index) => (
            <MenuItem key={item.id}>
              <div className='form-check d-flex align-items-center'>
                <input
                  key={`name${item.id}`}
                  type="checkbox"
                  className="form-check-input"
                  checked={selectedIds.includes(item.id)}
                  onChange={() => { }}
                  name={'check-' + index}
                  id={'check-' + index + item.id}
                />
                <div className="cursor-pointer">
                  <div className={`${item.id === -2 ? 'text-danger' : ''}`} htmlFor={'check-' + index}>
                    {item.name}{' '}
                  </div>
                </div>
              </div>
            </MenuItem>
          ))}
          {isLoading &&
            <div className='ml-15'>
              <ThreeDots className='justify-content-center' height='15' width='100' color='grey'></ThreeDots>
            </div>}
        </>
      </Menu>
    </div>
  );

  return (
    <>
      <div id={dropdownId}>
        <Dropdown
          trigger={['click']}
          onVisibleChange={handleVisibleChange}
          visible={visible}
          closeOnSelect={true}
          overlay={menu}
          overlayClassName='dropdown-style bg-white'
          animation="slide-up"
          getPopupContainer={() => document.getElementById(dropdownId)}>
          <div className="form-select d-flex align-items-center">
            <div className='form-placeholder cursor-pointer overflow-hidden'>{placeHolder}</div>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

Index.propTypes = {
  value: PropTypes.array,
  dropdownId: PropTypes.string,
  selectedIds: PropTypes.array,
  loadMoreData: PropTypes.func,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
  placeHolder: PropTypes.string,
  fetch: PropTypes.func,
  hasMore: PropTypes.bool,
  takeSize: PropTypes.number,
  isPaginated: PropTypes.bool
};

export default Index;
